import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import DefaultAction, { ActionLink, ActionButton } from "./Action.styled";

const BUTTON_TYPE = "button";
const INPUT_TYPE = "input";
const LINK_TYPE = "link";

const ELEMENT_TYPES = {
  link: ActionLink,
  button: ActionButton,
};

const Action = (props) => {
  const {
    elementType,
    label,
    children,
    className,
    disabled,
    onClick,
    type,
  } = props;

  const onClickHandle = useCallback(
    (event) => {
      if (elementType === BUTTON_TYPE || disabled) {
        event.preventDefault();
      }

      if (!disabled && onClick) {
        onClick(event);
      }
    },
    [disabled, elementType, onClick]
  );

  const value = useMemo(() => label || children, [children, label]);

  return (
    <DefaultAction
      {...props}
      as={ELEMENT_TYPES[elementType] || null}
      className={`make-click ${className || ""}`}
      onClick={onClickHandle}
      value={elementType === INPUT_TYPE ? value : null}
      type={elementType !== LINK_TYPE ? type : null}
    >
      {ELEMENT_TYPES[elementType] ? value : null}
    </DefaultAction>
  );
};

Action.defaultProps = {
  elementType: LINK_TYPE,
  type: BUTTON_TYPE,
  label: null,
  disabled: false,
  onClick: null,
};

Action.propTypes = {
  elementType: PropTypes.oneOf([INPUT_TYPE, BUTTON_TYPE, LINK_TYPE]),
  type: PropTypes.oneOf(["submit", BUTTON_TYPE, "reset"]),
  label: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Action;
